import { render } from "./Spin.vue?vue&type=template&id=3b1ba48f&scoped=true"
import script from "./Spin.vue?vue&type=script&lang=js"
export * from "./Spin.vue?vue&type=script&lang=js"

import "./Spin.vue?vue&type=style&index=0&id=3b1ba48f&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/simple-city-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b1ba48f"]])

export default __exports__